module.exports = __webpack_public_path__ + "img/5-m.e9719bb3.jpg";